// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__bnQxf","hover-animation":"LoadingScreen_hover-animation__GVAJb"};